import { render, staticRenderFns } from "./PeiTao.vue?vue&type=template&id=500933e8&scoped=true"
import script from "./PeiTao.vue?vue&type=script&lang=ts"
export * from "./PeiTao.vue?vue&type=script&lang=ts"
import style0 from "./PeiTao.vue?vue&type=style&index=0&id=500933e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500933e8",
  null
  
)

export default component.exports